// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__roobert_868fa6', '__roobert_Fallback_868fa6'"},"className":"__className_868fa6","variable":"__variable_868fa6"};